module.exports = __webpack_public_path__ + "static/media/civilLogo.d99bcfb7.png";